export enum ToastyMessageType {
  Default = 'default',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Custom = 'custom',
}
